import { useState, useEffect, useCallback } from "react";
import { activitiesApi } from "../lib/api";
import type { ActivityListItem } from "@runlens/shared";

interface UseRecentActivitiesResult {
  activities: ActivityListItem[];
  loading: boolean;
  error: string | null;
}

export function useRecentActivities(limit = 3): UseRecentActivitiesResult {
  const [activities, setActivities] = useState<ActivityListItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const { activities } = await activitiesApi.list({ limit });
      setActivities(activities);
    } catch {
      setError("Failed to load recent activities");
    } finally {
      setLoading(false);
    }
  }, [limit]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { activities, loading, error };
}
